import TableOfContents, {
  type TableOfContentsSection,
} from "@/components/Common/TableOfContents";

const sections: TableOfContentsSection[] = [
  {
    title: "Boolean Operations Guide",
    items: [
      { label: "Overview", id: "overview" },
      { label: "AND Operator", id: "and-operator" },
      { label: "OR Operator", id: "or-operator" },
      { label: "NOT Operator", id: "not-operator" },
      {
        label: "Combined Boolean Operations (AND, OR, NOT)",
        id: "combined-ops",
      },
    ],
  },
  {
    title: "API Navigation",
    items: [
      { label: "Authentication Standards", id: "auth-standards" },
      { label: "RESTful API Navigation", id: "rest-nav" },
      { label: "Error Handling", id: "error-handling" },
      { label: "Rate Limiting Compliance", id: "rate-limit" },
      { label: "Data Validation", id: "data-validation" },
      { label: "Security Considerations", id: "cm-security" },
    ],
  },
  {
    title: "Continuous Monitoring",
    items: [
      { label: "Efficient Polling Strategy", id: "polling" },
      { label: "Advanced Pagination Management", id: "pagination" },
      { label: "Strategic Sort Field Selection", id: "sorting" },
      { label: "Smart Search Pattern Usage", id: "smart-search" },
      {
        label: "Monitoring Implementation Checklist",
        id: "implementation-checklist",
      },
    ],
  },
  {
    title: "Data Confidentiality",
    items: [
      { label: "Classification Levels and Handling", id: "classification" },
      { label: "Mandatory Security Practices", id: "security-practices" },
    ],
  },
  {
    title: "Results Guide",
    items: [
      { label: "Core Article Fields", id: "core-article-fields" },
      {
        label: "Geographic & Temporal Fields",
        id: "geographic-temporal-fields",
      },
      { label: "Influencer/Author Information", id: "influencer-info" },
      { label: "Media Source Classification", id: "media-source" },
      { label: "Language Detection", id: "language-detection" },
      { label: "Engagement Metrics", id: "engagement-metrics" },
      { label: "Platform-Specific Field", id: "platform-field" },
      { label: "Influencer/Profile Data", id: "influencer-profile-data" },
    ],
  },
];

interface ContentsProps {
  onSectionSelect?: (sectionTitle: string) => void;
}

export default function Contents({ onSectionSelect }: ContentsProps) {
  return (
    <TableOfContents
      sections={sections}
      defaultOpenSection="Boolean Operations Guide"
      onSectionSelect={onSectionSelect}
    />
  );
}
